import classNames from "classnames";
import React, { FunctionComponent, ReactElement, useState } from "react";
import { ReactComponent as IconDown } from "../../../../../icons/chevron-down.svg";
import { ReactComponent as IconRight } from "../../../../../icons/chevron-right.svg";
import Link from "../../../../atoms/Link";
import OptionsListItem from "../OptionsListItem";
import "./style.scss";

interface Props {
  children?: ReactElement;
  closable?: boolean;
  globalButton?: {
    label: string;
    onClick: () => void;
  };
  icon: ReactElement;
  optionItems: Array<{
    assetUrl?: string;
    key?: string;
    label?: string;
    onSelect: () => void;
    price?: string;
    value: string;
  }>;
  selectedValue?: string;
  title: string;
  type?: "asset" | "color" | "layout" | "text";
}
const OptionList: FunctionComponent<Props> = ({
  children,
  closable = false,
  globalButton,
  optionItems,
  selectedValue,
  title,
  type,
}) => {
  const [opened, setOpened] = useState<boolean>(false);

  let listItem;
  if (type !== "layout") {
    listItem = (
      <OptionsListItem optionItems={optionItems} selectedValue={selectedValue} type={type} />
    );
  } else if (children) {
    listItem = children;
  }

  const handleClick = () => {
    if (closable) {
      setOpened((isOpened) => !isOpened);
    }
  };

  return (
    <div className="OptionList">
      <div
        className={classNames("OptionList-title", {
          "OptionList-title-action": closable,
          "OptionList-title-action--opened": opened,
        })}
        onClick={handleClick}
      >
        <span className="OptionList-title-text">{title}</span>
        {closable && opened && (
          <span className="OptionList-title-chevron">
            <IconDown />
          </span>
        )}
        {closable && opened === false && (
          <span className="OptionList-title-chevron">
            <IconRight />
          </span>
        )}
        {globalButton && (
          <Link onClick={globalButton.onClick} size="s">
            {globalButton.label}
          </Link>
        )}
      </div>
      <div className="OptionList-list">{listItem}</div>
    </div>
  );
};

export default OptionList;
